var _circle, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOccupancySeatsAvailable = function SvgOccupancySeatsAvailable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.25,
    cy: 5.5,
    r: 3.25,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m7.75 14-.169-1.518a3.352 3.352 0 0 0-6.662 0L.75 14z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 5.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 14-.155-1.443a2.862 2.862 0 0 0-5.69 0L9 14"
  }))));
};
export default SvgOccupancySeatsAvailable;